import { Check, Grading, Publish } from "@mui/icons-material";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { SurveyRecordVerification, useSurveyRecordVerificationEvidenceAddedMutation, useSurveyRecordVerificationEvidenceApprovedMutation, useSurveyRecordVerificationReviewEvidenceMutation } from "../../generated/graphql";
import useToast from "../../hooks/useToast";
import { Actions, Subjects } from "../../services/ability";
import { Maybe } from "../../types/types";
import { errorParser } from "../../utils/errorParser";
import MoreIconButton from "../MoreIconButton/MoreIconButton";
import Permission from "../Permission";
import { getAllowedTransitions } from "./Helpers/getAllowedTransitions";

interface SurveyRecordVerificationEvidenceMoreActionsProps {
    surveyRecordVerification: SurveyRecordVerification
    refetch: () => void
}

export default function SurveyRecordVerificationEvidenceMoreActions(props: SurveyRecordVerificationEvidenceMoreActionsProps) {
    const { refetch, surveyRecordVerification } = props
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [submitEvidence] = useSurveyRecordVerificationEvidenceAddedMutation()
    const [reviewEvidence] = useSurveyRecordVerificationReviewEvidenceMutation()
    const [approveEvidence] = useSurveyRecordVerificationEvidenceApprovedMutation()
    const { successToast, errorToast } = useToast()

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const transitionTo = async (obj: any) => {
        if (surveyRecordVerification?.id) {
            try {
                await obj.fn({ variables: { input: { surveyRecordVerification: surveyRecordVerification.id } } })
                successToast(obj?.successMessage ?? "Sucesso")
                refetch()
            } catch (e) {
                const errors = errorParser(e)
                errorToast(errors.join(","))
            }
        }
    }

    const getTransitionData = (currentState: Maybe<string>) => {

        const transitions: string[] = getAllowedTransitions(currentState)

        const actionsMap: any = [
            {
                stateTo: "2",
                icon: <Publish fontSize="small" />,
                label: "Submeter Evidência",
                action: Actions.SUBMIT,
                subject: Subjects.SURVEYRECORDVERIFICATION,
                fn: submitEvidence,
                successMessage: "Evidência submetida com sucesso"
            },
            {
                stateTo: "4",
                icon: <Grading fontSize="small" />,
                label: "Rever Evidência",
                action: Actions.REVIEW,
                subject: Subjects.SURVEYRECORDVERIFICATION,
                fn: reviewEvidence,
                successMessage: "Pedido de revisão submetido com sucesso"
            },
            {
                stateTo: "3",
                icon: <Check fontSize="small" />,
                label: "Aprovar Evidência",
                action: Actions.APPROVE,
                subject: Subjects.SURVEYRECORDVERIFICATION,
                fn: approveEvidence,
                successMessage: "Evidência aprovada com sucesso"
            },

        ]

        return actionsMap.filter((obj: any) => transitions.includes(obj.stateTo))
    }

    const allowedTransitions = getAllowedTransitions(surveyRecordVerification?.surveyRecordVerificationState?.id)

    return (
        <div>
            <MoreIconButton
                onClick={handleClick}
                disabled={!allowedTransitions?.length} />
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                sx={{ width: 500 }}

            >
                {
                    getTransitionData(surveyRecordVerification?.surveyRecordVerificationState?.id).map((obj: any) => {
                        return (
                            <Permission action={obj.action} subject={obj.subject} >
                                <MenuItem onClick={() => transitionTo(obj)}>
                                    <ListItemIcon>
                                        {obj.icon}
                                    </ListItemIcon>
                                    <ListItemText>{obj.label}</ListItemText>
                                </MenuItem>
                            </Permission>
                        )
                    })
                }
            </Menu>
        </div>
    )
}


